import React, { SVGProps } from "react";

export default function SupMoney(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2 9.99998C13.2 11.7673 11.7673 13.2 10 13.2C8.23269 13.2 6.8 11.7673 6.8 9.99998C6.8 8.23266 8.23269 6.79998 10 6.79998C11.7673 6.79998 13.2 8.23266 13.2 9.99998ZM12.4 9.99998C12.4 11.3255 11.3255 12.4 10 12.4C8.67452 12.4 7.6 11.3255 7.6 9.99998C7.6 8.67449 8.67452 7.59998 10 7.59998C11.3255 7.59998 12.4 8.67449 12.4 9.99998Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 14.8C18 15.6836 17.2837 16.4 16.4 16.4H3.6C2.71634 16.4 2 15.6836 2 14.8V5.19998C2 4.31632 2.71634 3.59998 3.6 3.59998H18V14.8ZM2.8 6.79998C4.12548 6.79998 5.2 5.72546 5.2 4.39998H15.0109C15.0109 5.6544 15.9733 6.68404 17.2 6.79084V13.1867C15.9733 13.2935 15.0109 14.3232 15.0109 15.5776C15.0109 15.5852 15.0113 15.5926 15.0122 15.6H5.19871C5.19957 15.5926 5.2 15.5852 5.2 15.5776C5.2 14.2521 4.12548 13.1776 2.8 13.1776V6.79998Z"
        fill="currentColor"
      />
    </svg>
  );
}
